import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServiceCard } from '../components/ServiceCard';
import { StatsSection } from '../components/StatsSection';
import { CTASection } from '../components/CTASection';
import { Flame, ThermometerSun, Snowflake, Wind, Wrench, Settings } from 'lucide-react';
import { motion } from 'framer-motion';
export function Home() {
  const services = [{
    title: 'Temporary Boilers',
    description: 'High-efficiency packaged boilers engineered for maximum performance. Available in multiple fuel configurations.',
    icon: Flame,
    path: '/boiler-hire'
  }, {
    title: 'Portable Heaters',
    description: 'Rapid deployment heating units suitable for industrial, commercial, and event applications.',
    icon: ThermometerSun,
    path: '/heater-hire'
  }, {
    title: 'Industrial Chillers',
    description: 'Robust process and comfort cooling systems designed for critical temperature control.',
    icon: Snowflake,
    path: '/chiller-hire'
  }, {
    title: 'Cooling Systems',
    description: 'Versatile air conditioning and evaporative cooling units for immediate temperature relief.',
    icon: Wind,
    path: '/cooling-hire'
  }, {
    title: 'Ancillary Equipment',
    description: 'Comprehensive supporting infrastructure including heat exchangers, pumps, and distribution.',
    icon: Wrench,
    path: '/ancillaries'
  }, {
    title: 'Sector Solutions',
    description: 'Tailored HVAC strategies for healthcare, manufacturing, facilities management, and more.',
    icon: Settings,
    path: '/services'
  }];
  return <main className="flex-grow" data-id="element-440">
      <HeroSection data-id="element-441" />

      <StatsSection data-id="element-442" />

      {/* Services Section */}
      <section className="py-24 bg-brand-light" data-id="element-443">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-444">
          <div className="flex flex-col md:flex-row justify-between items-end mb-16" data-id="element-445">
            <div className="max-w-2xl" data-id="element-446">
              <h2 className="text-brand-amber font-bold tracking-widest uppercase text-sm mb-3" data-id="element-447">
                What We Provide
              </h2>
              <h3 className="text-3xl md:text-5xl font-heading font-extrabold text-brand-navy" data-id="element-448">
                Equipment for Every Requirement
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-449">
            {services.map((service, index) => <ServiceCard key={index} title={service.title} description={service.description} icon={service.icon} delay={index * 0.1} path={service.path} data-id="element-450" />)}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-24 bg-white overflow-hidden" data-id="element-451">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-452">
          <div className="text-center mb-20" data-id="element-453">
            <h2 className="text-brand-amber font-bold tracking-widest uppercase text-sm mb-3" data-id="element-454">
              Our Process
            </h2>
            <h3 className="text-3xl md:text-5xl font-heading font-extrabold text-brand-navy" data-id="element-455">
              Seamless End-to-End Service
            </h3>
          </div>

          <div className="relative" data-id="element-456">
            {/* Connecting Line */}
            <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gray-200" data-id="element-457"></div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-458">
              {[{
              step: '01',
              title: 'Tell Us What You Need',
              desc: 'Contact our team with your requirements. We provide immediate technical guidance.'
            }, {
              step: '02',
              title: 'We Survey & Specify',
              desc: 'Our engineers assess your site and specify the exact equipment needed for optimal performance.'
            }, {
              step: '03',
              title: 'Delivered & Commissioned',
              desc: 'Equipment is dispatched nationwide and fully commissioned by our certified technicians.'
            }].map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.2
            }} className="bg-white" data-id="element-459">
                  <div className="w-24 h-24 bg-brand-navy rounded-full flex items-center justify-center text-3xl font-heading font-bold text-brand-amber mb-8 mx-auto md:mx-0 border-8 border-white shadow-lg" data-id="element-460">
                    {item.step}
                  </div>
                  <h4 className="text-2xl font-heading font-bold text-brand-navy mb-4 text-center md:text-left" data-id="element-461">
                    {item.title}
                  </h4>
                  <p className="text-brand-slate leading-relaxed text-center md:text-left" data-id="element-462">
                    {item.desc}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </section>

      <CTASection data-id="element-463" />
    </main>;
}